const proxy = require("../proxy.json");
const gatewayMode = proxy.gatewayMode ?? "";
const prodUrl = proxy.gatewayUrl.prod ?? "";
const localUrl = proxy.gatewayUrl.local ?? "";
const testUrl = proxy.gatewayUrl.test ?? "";

const api = (mode) => {
  let apiBaseUrl = "";
  switch (mode) {
    case "test":
      apiBaseUrl = `${testUrl}`;
      break;
    case "local":
      apiBaseUrl = `${localUrl}`;
      break;
    case "prod":
      apiBaseUrl = `${prodUrl}`;
      break;
    default:
      mode = "prod";
      apiBaseUrl = `${prodUrl}`;
      break;
  }
  apiBaseUrl = apiBaseUrl + "/api";

  return {
  // API MODE
  apiMode: mode,

  // API BASE URL
  apiBaseUrl: apiBaseUrl,

  // LOGIN
  login: `${apiBaseUrl}/login/login`,
  refresh: `${apiBaseUrl}/login/refresh`,
  requestRecoverPassword: `${apiBaseUrl}/login/recover-password-request`,
  recoverPassword: `${apiBaseUrl}/login/recover-password`,

  // REGISTRAZIONE
  register: `${apiBaseUrl}/registrazione/createAccount`,
  verify: `${apiBaseUrl}/registrazione/register/google`,
  facebook: `${apiBaseUrl}/registrazione/register/facebook`,

  // ACCOUNT
  modificaAccount: `${apiBaseUrl}/account/vendor/modifica`,
  eliminaAccount: `${apiBaseUrl}/account/vendor/elimina`,
  getVendorProfile: `${apiBaseUrl}/account/vendor/get-profile`,
  vendorPaymentMethodsGet: `${apiBaseUrl}/account/vendor/get-payment-methods`,
  vendorPaymentMethodsModifica: `${apiBaseUrl}/account/vendor/modifica-payment-methods`,

  // NOTIFICATIONS
  vendorNotificationsList: `${apiBaseUrl}/account/vendor/notifications/list`,
  vendorNotificationsState: `${apiBaseUrl}/account/vendor/notifications/state`,

  // VENDOR TICKETS
  vendorTicketNew: `${apiBaseUrl}/account/vendor-ticket/new`,
  vendorTicketList: `${apiBaseUrl}/account/vendor-ticket/list`,
  vendorTicketMessage: `${apiBaseUrl}/account/vendor-ticket/message`,
  vendorTicketMessageList: `${apiBaseUrl}/account/vendor-ticket/message/list`,
  vendorTicketMessageAttachment: `${apiBaseUrl}/account/vendor-ticket/message/attachment`,
  vendorTicketMessageEdit: `${apiBaseUrl}/account/vendor-ticket/message/edit`,
  vendorTicketSummary: `${apiBaseUrl}/account/vendor-ticket/summary`,
  vendorTicketMessagePoll: `${apiBaseUrl}/account/vendor-ticket/message/poll`,

  // CATALOG
  importCsv: `${apiBaseUrl}/catalog/import`,
  getCatalogs: `${apiBaseUrl}/catalog/action/getCatalogs`,
  getCatalogImportDetails: `${apiBaseUrl}/catalog/action/getCatalogImportDetails`,
  modifica: `${apiBaseUrl}/catalog/action/modifica`,
  
  // RICERCA
  productsSearch: `${apiBaseUrl}/ricerca/ricerca`,
  categorie: `${apiBaseUrl}/ricerca/get/categorie`,


  // CLICK and STATS
  click: `${apiBaseUrl}/click/click`,
  storico: `${apiBaseUrl}/click/storico`,
  vendorTopProductsByClick: `${apiBaseUrl}/click/vendor-stats/top-products-by-click`,
  vendorTraffic: `${apiBaseUrl}/click/vendor-stats/traffic`,
  vendorTopCategoriesByClick: `${apiBaseUrl}/click/vendor-stats/top-categories-by-click`,

  // INVIO EMAIL
  sendEmail: `${apiBaseUrl}/invioemail/sendEmail`,
  
  // BILLING PLANS SERVICE (Added endpoints)
  getVendorTransactions: (vendorId) => `${apiBaseUrl}/biling/customer/transactions/${vendorId}`,
  getVendorInvoices: (vendorId) => `${apiBaseUrl}/biling/customer/invoices/${vendorId}`,
  }
};

export default api(gatewayMode);


